export function createMutators() {
  return {};
}

export type Mutators = ReturnType<typeof createMutators>;
